import {
  Alert,
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import { CSVLink, CSVDownload } from "react-csv";
import React, { useRef, useState } from "react";
import OtherRadio from "../Radio/OtherRadio";
import Label from "../register/Label";
import axios from "axios";


import {
  PDFDownloadLink,
  Page,
  Text,
  View,
  Document,
  StyleSheet,
} from "@react-pdf/renderer";
import { LoadingButton } from "@mui/lab";
import { isFloat } from "../../src/utils/services";
import moment from "moment";
import MonthRange from "../DatePicker/MonthRange";
import { onExportCSV } from "../../src/utils/queries";
import CircleSpinner from "../Spinner/Index";
import { useEffect } from "react";
import { exportExcel } from "../../src/utils/exportExcel";

const styles = StyleSheet.create({
  page: { flexDirection: "column", padding: 25 },
  table: {
    fontSize: 10,
    width: 550,
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignContent: "stretch",
    flexWrap: "nowrap",
    alignItems: "stretch",
  },
  row: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-around",
    alignContent: "stretch",
    flexWrap: "nowrap",
    alignItems: "stretch",
    flexGrow: 0,
    flexShrink: 0,
    flexBasis: 35,
  },
  cell: {
    // borderStyle: "solid",
    // borderWidth: 2,
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: "auto",
    alignSelf: "stretch",
    paddingHorizontal: 1,
  },
  cellRight: {
    // borderStyle: "solid",
    // borderWidth: 2,
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: "auto",
    alignSelf: "stretch",
    alignItems: "flex-end",
    display: "flex",
    textAlign: "right",
    paddingHorizontal: 1,
  },
  header: {
    backgroundColor: "#eee",
  },
  headerText: {
    fontSize: 11,
    fontWeight: 1200,
    color: "#1a245c",
    margin: 8,
  },
  tableText: {
    margin: 10,
    fontSize: 10,
    color: "black",
  },
});

const PDF = ({ headers, rows }) => {
  return (
    <Document>
      <Page style={styles.page} size="A4" wrap>
        <View style={styles.table}>
          <View style={[styles.row, styles.header]}>
            {headers.map(({ label }) => (
              <Text style={[styles.headerText, styles.cell]}>{label}</Text>
            ))}
          </View>
          {rows.map((row) => (
            <View style={[styles.row]}>
              {Object.values(row).map((item) =>
                isFloat(item) ? (
                  <Text style={[styles.cellRight]}>{item}</Text>
                ) : (
                  <Text style={[styles.cell]}>{item}</Text>
                )
              )}
            </View>
          ))}
        </View>
      </Page>
    </Document>
  );
};

const ExportTableForm = ({
  setShow,
  exportNull = false,
  fields = [],
  setFields,
  route = "",
  checkAllFields,
  setCheckedFields,
  setExcelFileName,
  resetModalFields
}) => {
  const [state, setState] = React.useState({});

  // const ref = useRef(null);
  const today = moment();
  const [tableData, setTableData] = useState([]);
  const [date, setDate] = useState({ dateValue: [null, null] });

  const handleChange = (index, isChecked) => {
    const newFields = fields;
    newFields[index].checked = isChecked;
    setFields([...newFields]);
  };

  const checkAll = (isChecked) => {
    fields.map(field => field.checked = isChecked)
    const newFields = fields
    setFields([...newFields]);
    checkAllFields = isChecked
    const checkedFields = checkAllFields
    setCheckedFields(checkedFields)
  };


  const handleClose = (e) => {
    resetModalFields?.();
    setShow(false);
  };

  const allFalsy = (fields.some(field => field['checked'] === true)) || (date.dateValue[0] != null && date.dateValue[1] != null) ? false : true;

  const getFields = fields.filter((field) => field.checked);

  const fieldKeys = getFields.map((field) => field.key).join(",");

  const handleSubmit = (e, data) => {
    e.preventDefault();
  };

  const date_from = (date.dateValue[0]) ? moment(date.dateValue[0]).format("DD-MM-YYYY") : "";
  const date_to = (date.dateValue[1]) ? moment(date.dateValue[1]).format("DD-MM-YYYY") : "";

  const filter = `${fieldKeys}&date_from=${date_from}&date_to=${date_to}`;
  const filterArr = fieldKeys.split(',');

  const { refetch, isSuccess, isLoading, data } = onExportCSV(route, filter);

  useEffect(() => {
    if (isSuccess && data) {
      const donations = data?.data?.data?.map((donation) => {
        if (route == '/donations?donationtype&') {
          return {
            donation_detail_code: donation?.donation_detail_code,
            first_name: donation?.donation?.is_anonymous
              ? "anonymous" : donation?.donation?.donor?.first_name,
            last_name: donation?.donation?.is_anonymous
              ? "anonymous" : donation?.donation?.donor?.last_name,
            title: donation?.donation?.is_anonymous
              ? "anonymous" : donation?.donation?.donor?.title,
            address: donation?.donation?.is_anonymous
              ? "anonymous" : donation?.donation?.donor?.address_line_1,
            postal_code: donation?.donation?.is_anonymous
              ? "anonymous" : donation?.donation?.donor?.postal_code,
            created_at: moment(donation?.donation?.created_at).format("DD MMM YYYY HH:mm:ss"),
            type: donation?.donation_type?.type,
            donation_location: donation?.donation?.donation_location,
            apply_gift_aid_to_donation: donation?.donation?.apply_gift_aid_to_donation ? (donation?.donation_type?.gift_aid_eligible) ? "Eligible" : "Non Eligble" : "Non Eligble",
            amount: parseFloat(donation?.amount),
            net_amount: parseFloat(donation?.net_amount),
            claimable: donation?.donation?.apply_gift_aid_to_donation ? (donation?.donation_type?.gift_aid_eligible) ? donation?.claimable_amount : 0 : 0
          }
        }

        if (route.includes("/donations?channel=plate&")) {
          const typesString = donation?.other_donation_details
            .map(item => item.donation_type?.type)
            .filter(Boolean)
            .join(', ');

          return {
            other_donation_code: donation?.other_donation_code,
            date_of_donation: moment(donation?.date_of_donation).format("DD MMM YYYY HH:mm:ss"),
            date_paid_to_bank_account: moment(donation?.date_paid_to_bank_account).format("DD MMM YYYY HH:mm:ss"),
            donation_name: donation?.donation_name,
            amount: donation?.amount,
            note: donation?.note,
            channel: donation?.channel,
            collection_type: typesString,
            apply_gift_aid_to_donation: donation?.gift_eligibility_status,
            claimable: donation?.gift_amount,
          }
        }

        if (route.includes("/donations?channel=platedetails&")) {
          return {
            other_donation_details_code: donation?.other_donation_details_code,
            date_of_donation: moment(donation?.date_of_donation).format("DD MMM YYYY HH:mm:ss"),
            date_paid_to_bank_account: moment(donation?.date_paid_to_bank_account).format("DD MMM YYYY HH:mm:ss"),
            donation_name: donation?.donation_name,
            amount: donation?.amount,
            note: donation?.note,
            channel: donation?.channel,
            collection_type: donation?.type,
            apply_gift_aid_to_donation: donation?.gift_eligibility_status,
            claimable: donation?.gift_amount,
          }
        }

        if (route.includes("/donations?channel=envelope&")) {
          return {
            other_donation_code: donation?.other_donation_code,
            first_name: donation?.first_name,
            last_name: donation?.last_name,
            title: donation?.title,
            donor_address: donation?.donor_address,
            donor_postal_code: donation?.donor_postal_code,
            date_of_donation: moment(donation?.date_of_donation).format("DD MMM YYYY HH:mm:ss"),
            date_paid_to_bank_account: moment(donation?.date_paid_to_bank_account).format("DD MMM YYYY HH:mm:ss"),
            donation_name: donation?.donation_name,
            note: donation?.note,
            channel: donation?.channel,
            donation_type: donation?.donation_type.type,
            amount: donation?.amount,
            apply_gift_aid_to_donation: donation?.gift_eligibility_status,
            claimable: donation?.total_claimable,
          }
        }

        if (route == '/donations?channel=event&') {
          return {
            other_donation_code: donation?.other_donation_code,
            first_name: donation?.first_name,
            last_name: donation?.last_name,
            title: donation?.title,
            donor_postal_code: donation?.donor_postal_code,
            notes: donation?.note,
            event_date: moment(donation?.event_type?.event_date).format("DD MMM YYYY HH:mm:ss"),
            description: donation?.event_type?.description,
            amount: donation?.amount,
            name: donation?.event_type?.name,
            event_type: donation?.participant_or_donor,
            donor_address: donation?.donor_address,
            other_donation_code: donation?.other_donation_code,
            apply_gift_aid_to_donation: donation?.gift_eligibility_status,
            claimable: donation?.total_claimable,
          }

        }


        if (route.includes("/donations?") && !route.includes("/donations?donationtype&")) {
          return {
            donation_code: donation?.donation_code,
            donation_detail_code: donation?.donation_detail_code,
            first_name: donation?.is_anonymous
              ? "anonymous" : donation?.donor?.first_name,
            last_name: donation?.is_anonymous
              ? "anonymous" : donation?.donor?.last_name,
            title: donation?.is_anonymous
              ? "anonymous" : donation?.donor?.title,
            address: donation?.is_anonymous
              ? "anonymous" : donation?.donor?.address_line_1,
            postal_code: donation?.is_anonymous
              ? "anonymous" : donation?.donor?.postal_code,
            created_at: moment(donation?.created_at).format("DD MM YYYY HH:mm:ss"),
            type: donation?.donation_details?.map((detail) => detail?.donation_type?.type)?.join(', ') || donation?.type,
            donation_location: donation?.donation_location,
            apply_gift_aid_to_donation: donation?.gift_eligibility_status,
            amount_received: parseFloat(donation?.amount_after_refund),
            amount_donated: parseFloat(donation?.amount_donated),
            claimable: donation?.total_claimable,
          }
        }

        if (route.includes("/donors?")) {
          return {
            id: donation?.donor_code,
            name: `${donation?.first_name}  ${donation?.last_name}`,
            address: `${donation?.postal_code} - ${donation?.address_line_1}, ${donation?.city}, ${donation?.country?.country_code}`,
            postal_code: donation?.postal_code,
            email: donation?.user?.email,
            phone_number: donation?.phone_number,
            created_at: moment(donation?.created_at).format("DD MMM YYYY HH:mm:ss"),
            total_donation_amount: (filterArr.includes("total_donation_amount")) ? donation?.donations[0].total_donation_amount : "",
            number_of_donations: (filterArr.includes("number_of_donations")) ? donation?.donations[0].number_of_donations : "",
            average_donation: (filterArr.includes("average_donation")) ? parseFloat(donation?.donations[0].average_donation_amount) : "",
          };
        }

        if (route == '/other-incomes?channel=otherincome&') {
          return {
            other_income_code: donation?.other_income_code,
            name: donation?.name,
            amount: parseFloat(donation?.amount),
            tax: parseFloat(donation?.tax),
            date_of_donation: moment(donation?.date_of_donation).format("DD MMM YYYY"),
            claimable: donation?.amount != '' ? donation?.amount / 4 : 0.00,
            gift_aid_claimed: (donation?.gift_aid_claim_id) ? "Yes" : "No",
            notes: donation?.notes,
          }

        }

        else {
          return {
            registration_id: donation?.id,
            name: `${donation?.first_name}  ${donation?.last_name}`,
            address: donation?.address_line_1,
            postal_code: donation?.postal_code,
            email: donation?.user?.email,
            phone_number: donation?.phone_number,
            created_at: moment(donation?.created_at).format("DD MMM YYYY HH:mm:ss"),
            total_donation_amount: (filterArr.includes("total_donation_amount")) ? donation?.donations[0].total_donation_amount : "",
            number_of_donations: (filterArr.includes("number_of_donations")) ? donation?.donations[0].number_of_donations : "",
            average_donation: (filterArr.includes("average_donation")) ? donation?.donations[0].average_donation_amount : "",

            //refunds
            refund_id: (filterArr.includes("id")) ? donation?.id : "",
            donation_id: (filterArr.includes("donation_id")) ? donation?.donation_id : "",
            date_refund: (filterArr.includes("date_refund")) ? moment(donation?.created_at).format("DD MMM YYYY HH:mm:ss") : "",
            donor: (filterArr.includes("donor")) ? `${donation?.donation?.donor?.first_name}  ${donation?.donation?.donor?.last_name}` : "",
            notes: (filterArr.includes("notes")) ? donation?.notes : "",
            amount_donated: (filterArr.includes("amount_donated")) ? donation?.donation?.donation_details[0].total_donation_amount : "",
            total_amount_refund: (filterArr.includes("total_amount_refund")) ? donation?.total_refund_amount : "",
            new_donation_balance: (filterArr.includes("new_donation_balance")) ? donation?.donation?.amount_after_refund : "",
          };
        }
      });

      setTableData(donations);
      exportExcel({
        filename: setExcelFileName || "Excel File",
        sheetName: setExcelFileName || "Sheet1",
        columns: getFields,
        data: donations,
      });

      handleClose();
    }
  }, [isSuccess, data]);



  return (
    <>
      <form onSubmit={handleSubmit}>
        <Alert
          severity="error"
          color={"grey"}
          sx={{
            marginBlock: "1em",
            borderRadius: "8px",
            fontSize: "14px",
            border: "1px solid #EDF0F2",
            background: "#fafafa",
            color: "#425A70",
          }}
        >
          Select the columns you would like to be displayed in your exported
          list and then select the date range for your selections.
        </Alert>

        <Grid container spacing={2} mb={"2em"}>
          <Grid item xs={12} md={6}>
            <FormControlLabel
              onChange={checkAll}
              sx={{ width: "80%" }}
              control={
                <Checkbox
                  checked={checkAllFields}
                  onChange={(event) => checkAll(event.target.checked)}
                />
              }
              label="Check all fields"
            />
          </Grid>
        </Grid>

        <Typography
          variant="big"
          component={"p"}
          fontWeight={500}
          marginTop="9px"
          color="grey.dark"
        >
          Columns
        </Typography>


        <FormControl sx={{ marginBottom: "2em", width: "100%" }}>
          <FormGroup
            sx={{
              display: "flex",
              flexWrap: "wrap",
              width: "100%",
              flexDirection: "row",
            }}
          >
            {fields.map(({ label, key, checked }, i) => (
              <FormControlLabel
                onChange={handleChange}
                sx={{ width: "40%" }}
                control={
                  <Checkbox
                    checked={checked}
                    onChange={(event) => handleChange(i, event.target.checked)}
                    name={key}
                  />
                }
                label={label}
              />
            ))}
          </FormGroup>
        </FormControl>



        <div>
          <Typography
            variant="big"
            fontWeight={500}
            mb={"0.5em"}
            color={"#B37800"}
            component={'p'}
          >
            The export records will be limited to the date range you choose before.
          </Typography>
          <Typography
            variant="big"
            component={"p"}
            fontWeight={500}
            marginTop="9px"
            color="grey.dark"
          >
            {route == "/donors?" ? ("Date Registered") : ("Date range")}
          </Typography>
          <Grid container spacing={2} mb={"2em"}>
            <Grid item xs={12} md={6}>
              <Typography
                variant="big"
                component={"p"}
                fontWeight={500}
                marginTop="9px"
                color="grey.dark"
              >
                From
              </Typography>
              <MonthRange
                dateValue={date.dateValue}
                setDateValue={setDate}
                index={0}
                showYear
                // noError
                maxDate={moment()}
                openTo="month"
                views={["month", "day"]}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography
                variant="big"
                component={"p"}
                fontWeight={500}
                marginTop="9px"
                color="grey.dark"
              >
                To
              </Typography>
              <MonthRange
                dateValue={date.dateValue}
                setDateValue={setDate}
                index={1}
                // noError
                maxDate={moment()}
                showYear
                openTo="month"
                views={["month", "day"]}
              />
            </Grid>
          </Grid>
        </div>
        <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
          <Box>
            <Button
              onClick={() => {
                refetch();
              }}
              disabled={allFalsy}
              sx={{
                borderRadius: "8px",
                paddingY: "8px",
                paddingX: "12px",
                fontSize: "14px",
                fontWeight: "600",
                textTransform: "none",
                "&.Mui-disabled": {
                  opacity: "0.3",
                  backgroundColor: "primary.main",
                  color: "white",
                },
              }}
              variant="contained"
              color="primary"
              disableElevation
              disableFocusRipple
              disableRipple
            >
              {isLoading ? <CircleSpinner /> : "Export"}
            </Button>

            <Button
              onClick={handleClose}
              sx={{
                borderRadius: "8px",
                paddingY: "8px",
                paddingX: "12px",
                fontSize: "14px",
                fontWeight: "600",
                marginLeft: "1em",
                textTransform: "none",
                "&.Mui-disabled": {
                  opacity: "0.3",
                  backgroundColor: "primary.main",
                  color: "white",
                },
              }}
              color="primary"
              disableElevation
              disableFocusRipple
              disableRipple
            >
              Cancel
            </Button>
          </Box>
        </Box>
      </form>
      {/* ) : (
        <Box>
          <Alert
            severity="warning"
            color={"grey"}
            sx={{
              marginBlock: "1em",
              borderRadius: "8px",
              fontSize: "14px",
              border: "1px solid #FFEECC",
              background: "#FFFAF0",
              color: "#425A70",
              '& .MuiAlert-icon':{
                color:"#B37800"
              }
            }}
          >
            <Typography
              variant="big"
              fontWeight={500}
              mb={"0.5em"}
              color={"#B37800"}
              component={'p'}
            >
             No donations to export
            </Typography>
            There are no donations that meet the filter criteria in your current
            view. If you have filters applied but wish to export all donations,
            make sure to clear all filters before exporting.
          </Alert>
        </Box>
      )} */}
    </>
  );
};

export default ExportTableForm;
